import React, { FC } from 'react';
import classnames from 'classnames';
import { Icon } from '@sm/wds-react';

import { LogoProps } from './typings';

import './logo.scss';

const Logo: FC<LogoProps> = ({
  color = 'primary',
  className = '',
  ...other
}) => (
  <Icon className={classnames(`sm-logo--${color}`, className)} {...other}>
    ÷
  </Icon>
);

export default Logo;
